import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled__default from 'styled-components';
import themes from '../../theming/themes.js';
import React from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import _SideNavLink from './SideNavLink.js';

var _excluded = ["active", "theme", "children", "headerBackgroundColor", "links", "onClick"];
var _templateObject;
var StyledNavContainer = styled__default.nav(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
var SideNav = function SideNav(_ref) {
  var _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? themes["default"] : _ref$theme,
    children = _ref.children,
    _ref$headerBackground = _ref.headerBackgroundColor,
    links = _ref.links,
    _onClick = _ref.onClick,
    rest = _objectWithoutProperties(_ref, _excluded);
  var sideNavLinks = links && links.map(function (link, i) {
    return /*#__PURE__*/React.createElement(_SideNavLink, {
      theme: theme,
      to: "".concat(link.title),
      href: link.href,
      title: link.title,
      key: i,
      onClick: function onClick() {
        return _onClick;
      },
      exact: link.exact,
      active: active,
      "data-testid": "sidenav-link"
    }, link.text);
  });
  return /*#__PURE__*/React.createElement(StyledNavContainer, {
    "data-testid": "sidenav-container"
  }, links && links.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, sideNavLinks), children && children);
};
var _SideNav = withDefaultTheme(SideNav);

export default _SideNav;
